// eslint-disable-next-line import/no-cycle
import http from '../tools/http';

export default {
  async login({ email, password }) {
    return http.post('/auth', {
      email: email.trim(),
      password: password.trim(),
    }, {
      headers: {
        Authorization: '',
      },
      withCredentials: true,
    });
  },
  async loginOAuth({ authResponse, network }) {
    return http.post('/oauth', {
      network,
      access_token: authResponse.access_token,
    }, {
      headers: {
        Authorization: '',
      },
      withCredentials: true,
    });
  },
  async loginSSO(token) {
    return http.post('/saml-login', {
      token,
    }, {
      headers: {
        Authorization: '',
      },
      withCredentials: true,
    });
  },
  async refreshToken() {
    return http.post('/refresh-token', null, {
      headers: {
        Authorization: '',
      },
      withCredentials: true,
    });
  },
  async logoff() {
    return http.post('/logout', null, {
      headers: {
        Authorization: '',
      },
      withCredentials: true,
    });
  },
};
